import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { VehicleService } from '../services/vehicle.service';

@Component({
    selector: 'app-public',
    templateUrl: './public.component.html',
    encapsulation: ViewEncapsulation.None
})

export class PublicComponent implements OnInit {
    vehicleList: any = [];

    slides = [
        { img: "assets/images/chevrolet.png", alt: "Chevrolet" },
        { img: "assets/images/volkswagen.png", alt: "Volkswagen" },
        { img: "assets/images/toyota.png", alt: "Toyota" },
        { img: "assets/images/renault.jpg", alt: "Renault" },
        { img: "assets/images/honda.png", alt: "Honda" },
        { img: "assets/images/fiat.png", alt: "Fiat" },
        { img: "assets/images/nissan.png", alt: "Nissan" },
        { img: "assets/images/hyundai.png", alt: "Hyundai" },
    ];

    slideConfig = {
        "slidesToShow": 4,
        "slidesToScroll": 1,
        "lazyLoad": "ondemand",
        "infinite": true,
        'centerMode': true,
        'responsive': [
            {
                'breakpoint': 1024,
                'settings': {
                    'slidesToShow': 4,
                    'slidesToScroll': 1,
                }
            },
            {
                'breakpoint': 600,
                'settings': {
                    'dots': true,
                    'slidesToShow': 2,
                    'slidesToScroll': 2
                }
            },
            {
                'breakpoint': 480,
                'settings': {
                    'dots': true,
                    'slidesToShow': 1,
                    'slidesToScroll': 1
                }
            }
        ]
    };

    constructor(private vehicleService: VehicleService) { }

    ngOnInit(): void {
        this.getVehicles();
    }

    getVehicles() {
        this.vehicleService.geAlltVehicles(true).subscribe(data => {
            this.vehicleList = data;
        });
    }
}
